/**
 * Envío UI-2 · Vista Canvas / Vista Edición.
 *
 * Interruptor del layout nuevo. Sólo cambia DÓNDE se dibujan las ventanas:
 * los stores, el backend, el MCP y LMX no se tocan.
 *
 *  · REACT_APP_LAYOUT_V2=true  → layout nuevo para todos.
 *  · sin la variable (o false) → layout de siempre.
 *  · localStorage "sml.layoutV2" = "1" | "0" pisa la variable en ESE navegador
 *    (para probarlo en producción sin cambiárselo a nadie más).
 *    En la consola: localStorage.setItem('sml.layoutV2','1'); location.reload()
 */
export const LAYOUT_V2_KEY = 'sml.layoutV2';

export function resolveLayoutV2(envValue, storage) {
  let local = null;
  try { local = storage ? storage.getItem(LAYOUT_V2_KEY) : null; } catch { local = null; }
  if (local === '1') return true;
  if (local === '0') return false;
  return String(envValue ?? 'false').toLowerCase() === 'true';
}

const safeStorage = () => {
  try { return typeof window !== 'undefined' ? window.localStorage : null; } catch { return null; }
};

export const LAYOUT_V2 = resolveLayoutV2(process.env.REACT_APP_LAYOUT_V2, safeStorage());

// Ancho de la columna fija de LMX (abierta / plegada). Lo usa el CSS vía
// la variable --lmx-col-w que pone LmxDock.
export const LMX_COL_OPEN = 340;
export const LMX_COL_RAIL = 56;
